import ClassBChecks from './ClassBChecks';

export default ClassBChecks;